import { API_ASSETS_BASE_URL } from "../api/client";

export const resolveAssetUrl = (relativePath) => {
  if (!relativePath) return "";
  if (/^https?:\/\//i.test(relativePath)) return relativePath;
  return `${API_ASSETS_BASE_URL}${relativePath.startsWith("/") ? relativePath : `/${relativePath}`}`;
};
